import { render, staticRenderFns } from "./Dinamica.vue?vue&type=template&id=74b88202"
import script from "./Dinamica.vue?vue&type=script&lang=js"
export * from "./Dinamica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports